import { render } from "./Account.vue?vue&type=template&id=a92ea864&scoped=true&ts=true"
import script from "./Account.vue?vue&type=script&lang=ts"
export * from "./Account.vue?vue&type=script&lang=ts"

import "./Account.vue?vue&type=style&index=0&id=a92ea864&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a92ea864"]])

export default __exports__